//IMPORTS:
//EXTERNAL & PACKAGE 
//import $ from 'jquery'
//import Popper from 'popper.js'
import React from 'react'
import {graphql, Link} from 'gatsby'
//COMPONENT DEPENDENCIES
import Heading from '../../components/heading'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import PageHeader from '../../components/PageHeader'
import TextBlock from '../../components/textblock'
import Header from '../../components/Header'
import AccordionTableNew from '../../components/AccordionTableNew'
import VerticalMenuReporting from '../../components/VerticalMenuVulnerabilities'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles/accordionTable.css'
import '../../styles/verticalMenu.css'
import '../../styles/reportingInstructions.css'
import Iframe from 'react-iframe'
import Helmet from "react-helmet"
//*******************************************************************
//*******************************************************************  
const vulnerabilityDisclosurePolicyPage = ({data}) => {
    
    const vulnerabilityDisclosurePolicy = data.vulnerability_disclosure_policy_vdp.edges

    return (   
        
        <div>
            
            <Helmet>

                <title>Vulnerability Disclosure Policy (VDP)</title>
                <meta name="description" content="Information on how to report cybersecurity incidents to the NJCCIC."/>
				<script type="text/javascript" src="/filters.js"></script>		
				<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js" integrity="sha384-ka7Sk0Gln4gmtz2MlQnikT1wXgYsOg+OMhuP+IlRH9sENBO0LRn5q+8nbTov4+1p" crossorigin="anonymous"></script>
				<link rel="preconnect" href="https://fonts.googleapis.com"/> 
				<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin/>
				<link href="https://fonts.googleapis.com/css2?family=Nunito&family=Oswald&display=swap" rel="stylesheet"/>
                
            </Helmet>

            <Heading/>
            
            <Navbar/>

            {vulnerabilityDisclosurePolicy.map(({ node: {page_title, subtitle, table_of_contents_item, content_accordion} }) => (
        
                <div class="container-fluid reportingInstructionsContentBlock vdp">

                    <div class="container containerWidth">

                        <div class="row pageHeaderSection">

                            <PageHeader divClass="background" elementClass="pageHeader centerText leftText newHeaderFont" title="Vulnerability Disclosure Policy (VDP)"/>

                        </div>
                        
                        <div class="row strategicPlan">

                            <VerticalMenuReporting data={table_of_contents_item}/>

                            <AccordionTableNew layoutClass="accordionTable col-10 offset-1 col-lg-8 offset-lg-0 col-xl-9 reportingAccordion collapsed vdp" data={content_accordion}/>                     

                        </div>
                        
                    </div>
                    
                </div> 
        
            ))}
        
            <Footer/>
                            
        </div> 

    )   
    
}
//*******************************************************************
//******************************************************************* 
export const query = graphql`
    query {
        vulnerability_disclosure_policy_vdp: allButterPage(filter: {slug: { eq: "vulnerability-disclosure-policy-vdp" } }) {
            edges {
                node {
                    slug
                    page_title 
                    subtitle
                    table_of_contents_item {
                        title
                        data_target
                    }
                    content_accordion {  
                        type
                        fields {
                            accordion_item {
                                subheader
                                icon
                                main_text
                                subsection_id
                            }  
                        }                            
                    }
                }
            }
        }
    }
`
export default vulnerabilityDisclosurePolicyPage
//******************************************************************* // JavaScript Document